import React from 'react';
import TeamNotificationsListHeaders from '../../ChatTools/TeamNotificationListHeaders';

const TeamSettings = ({ history, applicationName }) => (
  <TeamNotificationsListHeaders
    applicationName={applicationName}
    history={history}
  />
);

export default TeamSettings;
